import {
	apiWidgetCancelMyBooking,
	apiWidgetGetMyBooking,
	apiWidgetReconfirmMyBooking,
	type WidgetMyBooking
} from '#lib/types/generated/index.js';
import { widgetConfig } from '#lib/widget/core.js';
import { refreshMember } from '#lib/widget/member.js';
import type { DateTime } from 'luxon';
import { derived, get, writable, type Readable } from 'svelte/store';

export const widgetMyBooking = writable<WidgetMyBooking | undefined>(undefined);

export const widgetMyBookingCancellationDate: Readable<DateTime | null | undefined> = derived(
	[widgetMyBooking],
	([$widgetMyBooking]) => {
		if (!$widgetMyBooking) return undefined;

		if ($widgetMyBooking.cancellationTimeBefore === null) {
			return null;
		}

		if ($widgetMyBooking.cancellationTimeBefore === 0) {
			return undefined;
		}

		return $widgetMyBooking.date.minus({ minutes: $widgetMyBooking.cancellationTimeBefore });
	}
);

export let bookingIsLoading = false;

export function fetchBooking(id: string): Promise<void> | undefined {
	if (bookingIsLoading) return;
	bookingIsLoading = true;
	const widgetHash = get(widgetConfig).hash;

	return apiWidgetGetMyBooking(widgetHash, id)
		.then((result) => {
			widgetMyBooking.set(result);
			bookingIsLoading = false;
		})
		.catch((e: unknown) => {
			bookingIsLoading = false;
			console.error(e);
			throw e;
		});
}

export const cancelBooking = async (booking: WidgetMyBooking): Promise<void> => {
	const widgetHash = get(widgetConfig).hash;

	const result = await apiWidgetCancelMyBooking(widgetHash, booking.id);
	widgetMyBooking.update((state) => {
		if (state) {
			state.status = result.status;
		}

		return state;
	});
	await refreshMember();
};

export const reconfirmBooking = async (booking: WidgetMyBooking): Promise<void> => {
	const widgetHash = get(widgetConfig).hash;

	const result = await apiWidgetReconfirmMyBooking(widgetHash, booking.id);
	widgetMyBooking.update((state) => {
		if (state) {
			state.status = result.status;
		}

		return state;
	});
};
